'use es6';

// cleanup nulls to grab default strings from record, we might need to
// TODO update the endpoints to return empty strings instead of nulls
export const cleanObject = (item, nullFn) => {
  if (!nullFn || typeof nullFn !== 'function') {
    nullFn = val => val == null;
  }
  const values = Object.assign({}, item);
  Object.keys(values).forEach(key => {
    if (nullFn(values[key])) {
      delete values[key];
    }
  });
  return values;
};

// Copied over from FileManagerUI https://git.hubteam.com/HubSpot/FileManagerUI/blob/master/FileManagerCore/static/js/utils/file.js#L35
export const splitNameAndExtension = file => {
  const name = file.name;
  /* eslint-disable no-useless-escape */
  const matches = name.match(/(.*)\.([^\.]+)$/);
  /* eslint-enable no-useless-escape */
  if (!matches) {
    return {
      extension: '',
      name
    };
  }
  return {
    name: matches[1],
    extension: matches[2].toLowerCase()
  };
};